<template>
  <dialog ref="dialog" class="chat-modal" :style="{ maxWidth: width }" @mousedown="onBackdropMousedown" @close="$emit('close')" @cancel="$emit('close')">
    <div class="chat-modal-header">
      <h5 class="mb-0 font-weight-bold">{{ title }}</h5>
      <button type="button" class="btn btn-sm btn-link text-muted" title="Close" @click="$emit('close')">
        <i class="fe fe-x" style="font-size: 1.1rem"></i>
      </button>
    </div>
    <div class="chat-modal-body">
      <slot />
    </div>
  </dialog>
</template>

<script>
// Native <dialog> so focus trapping, Escape-to-close and modal semantics
// come from the browser instead of a hand-rolled backdrop + role="dialog".
export default {
  name: "ChatModal",
  props: {
    title: { type: String, default: "" },
    width: { type: String, default: "640px" },
  },
  mounted() {
    this.$refs.dialog.showModal();
  },
  beforeDestroy() {
    if (this.$refs.dialog && this.$refs.dialog.open) this.$refs.dialog.close();
  },
  methods: {
    onBackdropMousedown(e) {
      if (e.target === this.$refs.dialog) this.$emit("close");
    },
  },
};
</script>

<style scoped>
.chat-modal {
  position: fixed;
  top: 6vh;
  margin: 0 auto;
  background: #fff;
  width: 100%;
  max-height: 88vh;
  overflow-y: auto;
  border: none;
  border-radius: 12px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.25);
  padding: 0;
  z-index: 1800;
}
.chat-modal::backdrop {
  background: rgba(15, 23, 42, 0.45);
}
.chat-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #e9ecef;
}
.chat-modal-body {
  padding: 20px;
}
</style>
